// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollable__scroll {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
  }
  .scrollable__wrapper {
    position: relative;
    width: 100%;
  }
  .scrollable__wrapper--can-scroll .scrollable__scroll {
        overflow-x: auto;
      }
  .scrollable__wrapper--content-has-shadow .scrollable__scroll {
        box-shadow: 0 2px 2px rgb(0, 0, 0, 0.3);
      }
  .scrollable__wrapper--content-has-shadow .scrollable__shadow {
        opacity: 1;
      }
  .scrollable__wrapper--leftmost-scroll .scrollable__shadow--left {
        opacity: 0;
      }
  .scrollable__wrapper--rightmost-scroll .scrollable__shadow--right {
        opacity: 0;
      }
  .scrollable__shadow {
    position: absolute;
    top: 0;
    width: 0;
    height: 100%;
    box-shadow: 0 0 10px 10px #f6f7f8;
    opacity: 0;
    transition: opacity 150ms;
  }
  .scrollable__shadow--left {
      left: 0;
    }
  .scrollable__shadow--right {
      right: 0;
    }
  .scrollable__wrapper--dark .scrollable__shadow {
      box-shadow: 0 0 0.625rem 0.625rem #1a1a1a;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
